import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const state = {
    currencies: {},
    currency: [],
    topCurrency: {},
    persons: [],
    person: {},
    personStep: 1,
    accountDetails: {},
    legal: {},
    step: 1,
};

const getters = {
    currencies(state) {
        return state.currencies;
    },
    currency(state) {
        return state.currency;
    },
    topCurrency(state) {
        return state.topCurrency;
    },
    persons(state) {
        return state.persons;
    },
    person(state) {
        return state.person;
    },
    personStep(state) {
        return state.personStep;
    },
    accountDetails(state) {
        return state.accountDetails;
    },
    legal(state) {
        return state.legal;
    },
    step(state) {
        return state.step;
    },
};

const mutations = {
    setCurrencies(state, currencies){
        state.currencies = currencies;
    },
    setCurrency(state, currency){
        state.currency = currency;
    },
    setTopCurrency(state, topCurrency){
        state.topCurrency = topCurrency;
    },
    setPerson(state, person){
        state.person = person;
    },
    setPersonStep(state, personStep){
        state.personStep = personStep;
    },
    setPersons(state, persons) {
        state.persons = persons;
    },
    setAccountDetails(state, accountDetails) {
        state.accountDetails = accountDetails;
    },
    setLegal(state, legal) {
        state.legal = legal;
    },
    setStep(state, step) {
        state.step = step;
    },
};

const actions = {
    setCurrencies({ commit, state }, currencies) {
        commit('setCurrencies', currencies);
        return state.currencies;
    },
    setCurrency({ commit, state }, currency) {
        commit('setCurrency', currency);
        return state.currency;
    },
    setTopCurrency({ commit, state }, topCurrency) {
        commit('setTopCurrency', topCurrency);
        return state.topCurrency;
    },
    setPerson({ commit, state }, person) {
        commit('setPerson', person);
        return state.person;
    },
    setPersonStep({ commit, state }, personStep) {
        commit('setPersonStep', personStep);
        return state.personStep;
    },
    setPersons({ commit, state }, persons) {
        commit('setPersons', persons);
        return state.persons;
    },
    setAccountDetails({ commit, state }, accoutDetails) {
        commit('setAccountDetails', accoutDetails);
        return state.accountDetails;
    },
    setLegal({ commit, state }, legal) {
        commit('setLegal', legal);
        return state.legal;
    },
    setStep({ commit, state }, step) {
        commit('setStep', step);
        return state.step;
    },
};

export default new Vuex.Store({
    actions,
    state,
    getters,
    mutations,
    plugins: [createPersistedState({
        storage: window.sessionStorage,
    })],
});
